/* tslint:disable */
/* eslint-disable */
/**
 * pb/signup.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ProtobufAny
 */
export interface ProtobufAny {
    [key: string]: object | any;

    /**
     * 
     * @type {string}
     * @memberof ProtobufAny
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface RequestAccessRequest
 */
export interface RequestAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'programmingLang'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'projectDesc'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestAccessRequest
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface RpcStatus
 */
export interface RpcStatus {
    /**
     * 
     * @type {number}
     * @memberof RpcStatus
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof RpcStatus
     */
    'message'?: string;
    /**
     * 
     * @type {Array<ProtobufAny>}
     * @memberof RpcStatus
     */
    'details'?: Array<ProtobufAny>;
}

/**
 * SignUpApi - axios parameter creator
 * @export
 */
export const SignUpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RequestAccessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess: async (body: RequestAccessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('requestAccess', 'body', body)
            const localVarPath = `/SignUp/RequestAccess`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignUpApi - functional programming interface
 * @export
 */
export const SignUpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignUpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RequestAccessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccess(body: RequestAccessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccess(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignUpApi.requestAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignUpApi - factory interface
 * @export
 */
export const SignUpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignUpApiFp(configuration)
    return {
        /**
         * 
         * @param {RequestAccessRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess(body: RequestAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.requestAccess(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignUpApi - object-oriented interface
 * @export
 * @class SignUpApi
 * @extends {BaseAPI}
 */
export class SignUpApi extends BaseAPI {
    /**
     * 
     * @param {RequestAccessRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignUpApi
     */
    public requestAccess(body: RequestAccessRequest, options?: RawAxiosRequestConfig) {
        return SignUpApiFp(this.configuration).requestAccess(body, options).then((request) => request(this.axios, this.basePath));
    }
}



